import React, { useState, useEffect } from 'react'

const Diff = require('diff')

const ProjectDemoContent = ({ fileName, keyText, downloadText, downloadExtractFile }) => {
  const [diffArr, setDiffArr] = useState([])

  useEffect(() => {
    const getData = async () => {
      try {
        const tempDiffArr = downloadText.split('\n').map((t, index) => {
          if (t) {
            return Diff.diffChars(t, downloadExtractFile.split('\n')[index])
          } else return [{ value: '', removed: true }]
        })
        setDiffArr(tempDiffArr)
      } catch (error) {
        console.error(error)
      }
    }

    if (fileName) {
      getData()
    }
  }, [fileName])

  return (
    <div className='w-full h-screen px-0 flex flex-col bg-gray-200 overflow-auto leading-4 lg:flex-row'>
      <div className='w-full min-h-[400px] overflow-scroll lg:w-1/2 lg:h-full p-4 text-xs'>
        <span className='font-bold'>분홍: 전처리 제거된 부분 / 노랑: 요약으로 사용된 부분</span>
        <hr />
        {diffArr.map((textArr, index) => {
          const tempData = textArr.map(t => {
            if (t.added)
              return (
                <span key={t.value} className='font-medium bg-lime-400'>
                  {t.value}
                </span>
              )
            else if (t.removed)
              return (
                <span key={t.value} className='font-medium bg-rose-200 leading-relaxed'>
                  {t.value}
                </span>
              )
            else
              return (
                <span key={t.value} className='font-medium bg-yellow-200 leading-relaxed'>
                  {t.value}
                </span>
              )
          })
          return (
            <div key={index}>
              {tempData}
              <br />
            </div>
          )
        })}
      </div>
      <div className='w-full p-4 text-xs lg:w-1/2'>
        <div className='flex flex-col'>
          <div style={{ minHeight: 400 }}>
            <span className='font-bold'>중요 문장 표시</span>
            <hr />
            <div>
              {keyText &&
                keyText.map((item, index) => (
                  <div key={index} className='mb-3 leading-5'>
                    <span>{item}</span>
                  </div>
                ))}
            </div>
          </div>
          <div className='mt-4' style={{ height: 400 }}>
            <span className='font-bold'>문서 요약 표시</span>
            <br />
            <hr />
            <span>{/* 내용 들어갈 부분 */}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectDemoContent
